import http from 'services/http';
import URIS from 'constants/uris';

getCarriers.operation = 'READ';
export function getCarriers({ country }) {
  return http
    .get(`${URIS.SHOP_CARRIERS}?country=${country}`)
    .then(({ data }) => data);
}
